import React from "react";
import * as Icons from "lucide-react";

export const inputCls = "w-full min-h-[52px] px-4 rounded-xl bg-white border border-[#D6CFC2] text-lg text-[#1C2421] focus:outline-none focus:ring-2 focus:ring-[#3A6B56]";

export const Campo = ({ label, opcional, error, ayuda, children, testid }) => (
  <div className="space-y-1.5" data-testid={testid}>
    <p className="text-base font-semibold text-[#1C2421]">{label}{opcional && <span className="font-normal text-[#6E7A74]"> (opcional)</span>}</p>
    {children}
    {ayuda && !error && <p className="text-sm text-[#6E7A74]">{ayuda}</p>}
    {error && <p className="text-sm font-semibold text-[#B91C1C] flex items-center gap-1.5" role="alert"><Icons.AlertCircle size={15} /> {error}</p>}
  </div>
);

export const Pregunta = ({ children }) => <h3 className="font-heading text-xl font-bold text-[#1C2421] pt-2">{children}</h3>;

// Opción grande tipo radio: el estado se indica también con el círculo marcado, no solo con color.
export const Opcion = ({ sel, onClick, titulo, texto, testid, casilla = false }) => (
  <button type="button" data-testid={testid} aria-pressed={sel} role={casilla ? "checkbox" : undefined} aria-checked={casilla ? sel : undefined} onClick={onClick}
    className={`w-full min-h-[60px] text-left rounded-2xl border-2 px-4 py-3 flex items-start gap-3 transition-colors ${sel ? "border-[#3A6B56] bg-[#F0F6F2]" : "border-[#E5DFD5] bg-white hover:border-[#C9D8CF]"}`}>
    <span className={`mt-0.5 w-6 h-6 ${casilla ? "rounded-[5px]" : "rounded-full"} border-2 shrink-0 flex items-center justify-center ${sel ? "border-[#3A6B56] bg-[#3A6B56]" : "border-[#B8B0A2]"}`}>
      {sel && <Icons.Check size={14} className="text-white" strokeWidth={3} />}
    </span>
    <span><span className="block text-lg font-semibold text-[#1C2421]">{titulo}</span>{texto && <span className="block text-base text-[#4A5550] mt-0.5">{texto}</span>}</span>
  </button>
);

export const Aviso = ({ children, testid, tone = "info" }) => (
  <div data-testid={testid} className={`rounded-2xl px-4 py-3 text-base flex gap-2.5 ${tone === "info" ? "bg-[#F0F6F2] text-[#2E5645]" : "bg-[#FFFBEB] text-[#92400E]"}`}>
    <Icons.Info size={20} className="shrink-0 mt-0.5" /> <span>{children}</span>
  </div>
);
